import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { PlanKindDisplayEnum, PlanKindEnum } from "src/app/shared/enums/plan-enums";

export interface PlanChangeKindModalOptions {
  serviceTreeId: string;
  planName: string;
  currentKind?: PlanKindEnum | string | null;
}

@Component({
  standalone: false,
  templateUrl: "./plan-change-kind-modal.component.html",
  styleUrls: ["../../../../styles.scss", "../../plan.scss"],
})
export class PlanChangeKindModalComponent implements OnInit {
  @Input() options: PlanChangeKindModalOptions;
  newKind: PlanKindEnum;
  planKindList: { key: string; value: string }[] = Object.keys(PlanKindDisplayEnum)
    .map((k) => ({ key: k, value: (PlanKindDisplayEnum as any)[k] }));

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    if (this.options?.currentKind && Object.values(PlanKindEnum).includes(this.options.currentKind as PlanKindEnum)) {
      this.newKind = this.options.currentKind as PlanKindEnum;
    }
  }

  isSubmitDisabled(): boolean {
    return !this.newKind || this.newKind === (this.options?.currentKind as PlanKindEnum);
  }

  submit(): void {
    if (this.isSubmitDisabled()) {
      return;
    }
    this.activeModal.close(this.newKind);
  }
}
